

<div class="container mt-5">
    <div class="card card-primary">
  
      <!-- /.card-header -->
      <!-- form start -->
      <div class="row">
        <form id="quickForm" [formGroup]="eventForm" (ngSubmit)="onSubmit()">
          <div class="card-body">
           <div class="row">
            <div class="col-6">
              <div class="form-group">
                <app-form-field label="{{ 'First Name' }}" [required]="true" [control]="eventForm.controls['firstName']"
                  [isInline]="false">
                  <app-input formControlName="firstName"></app-input>
                </app-form-field>
              </div>
            </div>
           
           <div class="col-6">
            <div class="form-group">
              <app-form-field label="{{ 'Last Name' }}" [required]="true" [control]="eventForm.controls['lastName']"
                [isInline]="false">
                <app-input formControlName="lastName"></app-input>
              </app-form-field>
            </div>
           </div>

           </div>
            <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <app-form-field label="{{ 'Email' }}" [required]="true" [control]="eventForm.controls['email']"
                    [isInline]="false">
                    <app-input formControlName="email"></app-input>
                  </app-form-field>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <app-form-field label="{{ 'Password' }}" [required]="true" [control]="eventForm.controls['password']"
                    [isInline]="false">
                    <app-input formControlName="password"></app-input>
                  </app-form-field>
                </div>
              </div>
            </div>
            
            <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <app-form-field label="{{ 'Mobile Number' }}" [required]="true" [control]="eventForm.controls['mobileNumber']"
                    [isInline]="false">
                    <app-input formControlName="mobileNumber"></app-input>
                  </app-form-field>
                </div>
              </div>
              <!-- <div class="col-6">
                <div class="form-group">
                    <app-form-field label="{{ 'isMobileUser' }}" [required]="true" [control]="eventForm.controls['isMobileUser']"
                    [isInline]="false">
                    <app-select [items]="isMobileUser" formControlName="isMobileUser"></app-select>
                  </app-form-field>
                </div>
              </div> -->
            </div>
            
            <div class="row">
              <!-- <div class="col-6">
                <app-form-field label="{{ 'isTestAccount' }}" [required]="true" [control]="eventForm.controls['isTestAccount']"
                    [isInline]="false">
                    <app-select [items]="isTestAccount" formControlName="isTestAccount"></app-select>
                  </app-form-field>
        
              </div>-->
              <div class="col-6"> 
                <!-- <div class="form-group">
  
                  <app-form-field label="{{ 'User Role' }}" [required]="true" [control]="eventForm.controls['roleType']"
                    [isInline]="false">
                    <app-select [items]="userRole" formControlName="roleType"></app-select>
                   
                  </app-form-field>
                </div> -->
              </div>
            </div>
          </div>
          <!-- /.card-body -->
          <div class="card-footer">
            <button type="button" class="btn btn-primary" (click)="onSubmit()">Submit</button> &nbsp;&nbsp;
            <button type="button" class="btn btn-outline-dark" (click)="activeModal.dismiss({ refresh: false })">
              Close
            </button>
          </div>
        </form>
      </div>
    </div>
  
  
  </div>
  <script src="../../plugins/jquery/jquery.min.js"></script>
  <script src="../../plugins/bootstrap/js/bootstrap.bundle.min.js"></script>
  <!-- Select2 -->
  <script src="../../../../assets/plugins/select2/js/select2.full.min.js"></script> 
  
  <script>
    $(function () {
      //Initialize Select2 Elements
      $('.select2').select2()
  
      //Initialize Select2 Elements
      $('.select2bs4').select2({
        theme: 'bootstrap4'
      })
    })
  </script>